import {lazy} from "react";
import not_found from "./not_found";

const home                  = lazy(() => import("./home"));
const help_center           = lazy(() => import("./help_center"));
const administrator_company = lazy(() => import("./administrator_company"));
const gas_station_company   = lazy(() => import("./gas_company"));
const carrier_company       = lazy(() => import("./carrier_company"));
const administration        = lazy(() => import("./administration"));
const invoice               = lazy(() => import("./invoice"));
const transaction           = lazy(() => import("./transaction"));
const basket                = lazy(() => import("./basket"));
const history               = lazy(() => import("./history"));
const alert                 = lazy(() => import("./alert"));
const statistic             = lazy(() => import("./statistic"));
const price_analysis        = lazy(() => import("./price_analysis"));
const tracker               = lazy(() => import("./tracker"));
const search                = lazy(() => import("./search"));
const contract              = lazy(() => import("./contract"));
const discount              = lazy(() => import("./discount"));
const bank_transfer         = lazy(() => import("./bank_transfer"));
const download              = lazy(() => import("./download"));
const removeAccount         = lazy(() => import("./removeAccount"));
const securityGroup         = lazy(() => import("./securityGroup"));

const pages = {
    home,
    administration,
    administrator_company,
    gas_station_company,
    carrier_company,
    invoice,
    transaction,
    basket,
    history,
    alert,
    statistic,
    price_analysis,
    tracker,
    search,
    contract,
    discount,
    bank_transfer,
    help_center,
    download,
    removeAccount,
    securityGroup,
    not_found
}

export default pages;
